import {createActionGroup} from '@ngrx/store';
import {VIEWPORT_FEATURE_KEY, ViewportSize} from './viewport.types';

export const ViewportActions = createActionGroup({
  source: VIEWPORT_FEATURE_KEY,
  events: {
    'Size Changed': (newSize: ViewportSize) => ({newSize})
  }
});
